// extracted by mini-css-extract-plugin
export default {"spinner":"IzuRrMW","rotate":"tyhbb4M"};